import { Button, Typography } from '@recruit-robin/robin-theme/web-components';
import { File_04, Upload_01, XClose } from '@recruit-robin/robin-theme/web-icons';
import { useContext } from 'react';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useCreateEnrichedVacancy } from '../../../../hooks/useCreateEnrichedVacancy';
import { useStyles } from './CreateFromFileUpload.styles';
import { useFileEvents } from './useFileEvents';

export const CreateFromFileUpload = ({ goBackButton }: { goBackButton: React.ReactNode }) => {
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);
  const { handleCreateFromFileUpload } = useCreateEnrichedVacancy();

  const {
    file,
    fileInputRef,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    handleFileSelect,
    handleRemoveFile,
    isDragging,
  } = useFileEvents();

  const handleSubmit = async () => {
    if (!file) return;

    handleCreateFromFileUpload(file);
  };

  return (
    <div css={classes.root}>
      <div css={classes.header}>
        <Upload_01 />
        <Typography variant={(v) => v.heading[4]} color={(c) => c.neutral.variant[70]}>
          {dictionary.uploadFile}
        </Typography>
      </div>

      <div
        css={[classes.dropArea, isDragging && classes.dropAreaDragging]}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}>
        <input
          ref={fileInputRef}
          type="file"
          accept=".pdf,.doc,.docx"
          onChange={handleFileSelect}
          css={classes.fileInput}
          id="file-upload"
        />
        <label htmlFor="file-upload" css={classes.fileInputLabel}>
          {file ? (
            <div css={classes.fileInfo}>
              <File_04 size={24} />
              <Typography variant={(v) => v.body.long} color={(c) => c.neutral.variant[70]}>
                {file.name}
              </Typography>
              <button css={classes.removeButton} onClick={handleRemoveFile}>
                <XClose size={18} />
              </button>
            </div>
          ) : (
            <>
              <Upload_01 size={24} />
              <Typography variant={(v) => v.body.long} color={(c) => c.neutral.variant[70]}>
                {dictionary.chooseFile}
              </Typography>
              <Typography variant={(v) => v.supporting.label} color={(c) => c.neutral.variant[40]}>
                {dictionary.noFileChosen}
              </Typography>
            </>
          )}
        </label>
      </div>

      <div css={classes.submitButtonWrapper}>
        {goBackButton}

        <Button style="filled" type="default" onClick={handleSubmit} disabled={!file} label={dictionary.processJob} />
      </div>
    </div>
  );
};
